export default __webpack_public_path__ + "static/media/SampleBlackout.ed59da3f.png";